import React from 'react'
import { useSelector } from 'react-redux'
import { selectTopSearchLinks } from '../../../store/seo/seo.selectors'
import TopSearchItem from '../../genericComponents/topSearch/TopSearchItem'
import T from '../../i18n/T'
import s from './TopSearchLinks.less'
import { selectShouldDisplayTopSearchTitle } from './seo-footer.selectors'

const ID = 'TopSearchLinks'

let html

export const TopSearchLinks = () => {
  const topSearchLinks = useSelector(selectTopSearchLinks)
  const shouldDisplayTitle = useSelector(selectShouldDisplayTopSearchTitle)

  if (__BROWSER__) {
    if (document.getElementById(ID)?.innerHTML) html = document.getElementById(ID)?.innerHTML
    if (!html) return <></>
    return <div id={ID} dangerouslySetInnerHTML={{ __html: html }} className={s.root}></div>
  }

  if (!topSearchLinks || topSearchLinks.length === 0) return <></>

  return (
    <div id={ID}>
      {shouldDisplayTitle === true && (
        <h2 className={s.title}>
          <T id={'footer.top-search.title'} />
        </h2>
      )}
      {topSearchLinks.map((links, idx) => (
        <TopSearchItem {...links} key={idx} />
      ))}
    </div>
  )
}

export default TopSearchLinks
